// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-products-product-additional-wrapper-hidden-bgrda{height:0;overflow:hidden;pointer-events:none;visibility:hidden}.components-products-product-additional-wrapper-loading-fmqxa{height:100px;width:100px}.components-products-product-additional-wrapper-loadingWrapper-bbayn{height:100px;width:100%;align-items:center;display:flex;justify-content:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hidden": "components-products-product-additional-wrapper-hidden-bgrda",
	"loading": "components-products-product-additional-wrapper-loading-fmqxa",
	"loadingWrapper": "components-products-product-additional-wrapper-loadingWrapper-bbayn"
};
module.exports = ___CSS_LOADER_EXPORT___;
